import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { WorkspaceSummary } from '@helios/state-management'

@Component({
  selector: 'hs-delete-workspace-confirmation',
  templateUrl: './delete-workspace-confirmation.component.html',
})
export class DeleteWorkspaceConfirmationComponent {
  workspaceToDelete: WorkspaceSummary | null = null

  constructor(readonly activeModal: NgbActiveModal) {}
}
